import { initBuildABoxPage } from '../theme/build_a_box'

initBuildABoxPage()
